import React, { Fragment } from "react"
import { connect } from "react-redux"

import ConceptTag from "../ConceptTag"

import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

const ViewFeedItemInsightDetails = ({
    header = "Insight areas",
    topics,
    isFetching
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            {header}
        </h3>
        <div className="widget-content tags concepts-box clearfix auto">
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={3}
            >
                {topics && topics.length > 0 ? (
                    <Fragment>
                        {topics.map(topic => (
                            <ConceptTag
                                key={topic.id}
                                parentPrefix={header}
                                concept={topic}
                                canEdit={false}
                                uri={`/insight-areas/${topic.id}`}
                            />
                        ))}
                    </Fragment>
                ) : (
                    <p>No insight areas</p>
                )}
            </ContentLoaderTags>
        </div>
    </div>
)

const mapStateToProps = (state, { topics }) => ({
    topics
})

export default connect(mapStateToProps)(ViewFeedItemInsightDetails)
